import { render, staticRenderFns } from "./TaskModelPage.vue?vue&type=template&id=6d25256f&"
import script from "./TaskModelPage.vue?vue&type=script&lang=js&"
export * from "./TaskModelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports